/*
 * @Author: ningbo.kang
 * @Date: 2019-12-14 18:28:01
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2023-06-12 16:52:18
 * @Description: 输出组件，并且提供安装install方法
 */
// 自定义表单
import wgForm from './widget-container/wg-form';
// 处理递归数据组件
import wgList from './widget-container/wg-list';
// 容器类组件
import wgTabs from './widget-container/wg-tabs';
import wgCard from './widget-container/wg-card';
import wgGrid from './widget-container/wg-grid';

// 表单域基础组件
import wgBlank from './widget-items/wg-blank';
import wgCascader from './widget-items/wg-cascader';

import wgDivider from './widget-items/wg-divider';
import wgFileupload from './widget-items/wg-fileupload';
import wgInput from './widget-items/wg-input';
import wgHidden from './widget-items/wg-hidden';
import wgHtml from './widget-items/wg-html';
import wgLink from './widget-items/wg-link';

import wgNumber from './widget-items/wg-number';
import wgTextarea from './widget-items/wg-textarea';
import wgText from './widget-items/wg-text';
import wgSlider from './widget-items/wg-slider';
import wgSwitch from './widget-items/wg-switch';
import wgRadio from './widget-items/wg-radio';
import wgCheckbox from './widget-items/wg-checkbox';
import wgSelect from './widget-items/wg-select';
import wgRate from './widget-items/wg-rate';
import wgDate from './widget-items/wg-date';
import wgTime from './widget-items/wg-time';
import wgTreeSelect from './widget-items/wg-treeSelect';
import wgDialog from './widget-items/wg-dialog';
import wgDateRange from './widget-items/wg-dateRange'; // 新增日期范围选择器
import wgProcessSelect from './widget-items/wg-processSelect';
import wgCompute from './widget-items/wg-compute'; // 计算组件

// 高级组件
import wgTable from './widget-items/wg-table';
import locale from './locale';

import './css/index.less';

const components = [
  wgForm,
  wgList,
  wgTabs,
  wgCard,
  wgGrid,
  wgBlank,
  wgCascader,
  wgDivider,
  wgFileupload,
  wgInput,
  wgHidden,
  wgHtml,
  wgLink,
  wgNumber,
  wgTextarea,
  wgText,
  wgSlider,
  wgSwitch,
  wgRadio,
  wgCheckbox,
  wgSelect,
  wgRate,
  wgDate,
  wgTime,
  wgTable,
  wgTreeSelect,
  wgDialog,
  wgDateRange,
  wgProcessSelect,
  wgCompute,
];

const install = function install(Vue, opts = {}) {
  // eslint-disable-next-line import/no-named-as-default-member
  locale.use(opts.locale);
  // eslint-disable-next-line import/no-named-as-default-member
  locale.i18n(opts.i18n);

  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  version: process.env.VUE_APP_VERSION,
  install,
};
